// @spec GHG-STR-050
'use client';

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import * as z from 'zod';

import { useCompareEmissionScenarios } from '@/features/ghg/api/use-scenarios';
import { ScenarioComparison } from '@/features/ghg/components/ScenarioComparison';
import i18n from '@/lib/i18n';

const searchSchema = z.object({
  scenarioIds: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/ghg/scenarios/compare')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.compareScenarios'),
  }),
  validateSearch: searchSchema,
  component: CompareScenarioPage,
});

/**
 * Scenario comparison page.
 *
 * Displays side-by-side comparison of multiple emission scenarios
 * with trajectory charts and summary metrics.
 */
function CompareScenarioPage() {
  const { t } = useTranslation('ghg');
  const { scenarioIds: scenarioIdsParam } = Route.useSearch();
  const scenarioIds = scenarioIdsParam ? scenarioIdsParam.split(',').filter(Boolean) : [];

  const { comparison, isLoading } = useCompareEmissionScenarios(scenarioIds);

  if (scenarioIds.length < 2) {
    return (
      <div className="p-8">
        <div className="mx-auto max-w-6xl py-16 text-center">
          <h1 className="mb-4 text-2xl font-semibold">{t('scenarioComparison.compareTitle')}</h1>
          <p className="text-muted-foreground">
            {t('scenarioComparison.compareDescription')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <div className="mx-auto max-w-6xl">
        <ScenarioComparison comparison={comparison} isLoading={isLoading} />
      </div>
    </div>
  );
}
